export {
  MorphemeMnemonicsPanelMeaningTabButton,
  type MorphemeMnemonicsPanelMeaningTabButtonProps,
} from "#morpheme-mnemonics-panel-meaning-tab-button";
